
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class LevelReportGrid extends Serenity.EntityGrid<LevelReportRow, any> {
        protected getColumnsKey() { return LevelReportColumns.columnsKey; }
        protected getDialogType() { return LevelReportDialog; }
        protected getIdProperty() { return LevelReportRow.idProperty; }
        protected getInsertPermission() { return LevelReportRow.insertPermission; }
        protected getLocalTextPrefix() { return LevelReportRow.localTextPrefix; }
        protected getService() { return LevelReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}